"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buyerDisplayHelper;
function buyerDisplayHelper(_ref) {
    var _ref$buyerOwnsActiveH = _ref.buyerOwnsActiveHold,
        ownsActiveHold = _ref$buyerOwnsActiveH === undefined ? false : _ref$buyerOwnsActiveH,
        _ref$buyerHasTradePer = _ref.buyerHasTradePermission,
        hasTradePermission = _ref$buyerHasTradePer === undefined ? false : _ref$buyerHasTradePer,
        _ref$itemIsOnHold = _ref.itemIsOnHold,
        isOnHold = _ref$itemIsOnHold === undefined ? false : _ref$itemIsOnHold,
        _ref$itemIsSold = _ref.itemIsSold,
        isSold = _ref$itemIsSold === undefined ? false : _ref$itemIsSold,
        _ref$itemIsFurniture = _ref.itemIsFurniture,
        isFurniture = _ref$itemIsFurniture === undefined ? false : _ref$itemIsFurniture,
        _ref$pricingShowSale = _ref.pricingShowSale,
        showSale = _ref$pricingShowSale === undefined ? false : _ref$pricingShowSale,
        _ref$pricingHideRetai = _ref.pricingHideRetail,
        hideRetail = _ref$pricingHideRetai === undefined ? false : _ref$pricingHideRetai,
        _ref$pricingValidNet = _ref.pricingValidNet,
        validNet = _ref$pricingValidNet === undefined ? false : _ref$pricingValidNet,
        _ref$pricingNegotiabl = _ref.pricingNegotiableSale,
        negotiableSale = _ref$pricingNegotiabl === undefined ? false : _ref$pricingNegotiabl,
        _ref$pricingNegotiabl2 = _ref.pricingNegotiableRetail,
        negotiableRetail = _ref$pricingNegotiabl2 === undefined ? false : _ref$pricingNegotiabl2,
        _ref$transactionIsBuy = _ref.transactionIsBuyerOfferWithReserve,
        isBuyerOfferWithReserve = _ref$transactionIsBuy === undefined ? false : _ref$transactionIsBuy,
        _ref$transactionIsFul = _ref.transactionIsFullPriceOrder,
        isFullPriceOrder = _ref$transactionIsFul === undefined ? false : _ref$transactionIsFul,
        _ref$transactionHasDe = _ref.transactionHasDealerSubmittedOfferAction,
        hasDealerSubmittedOfferAction = _ref$transactionHasDe === undefined ? false : _ref$transactionHasDe,
        _ref$transactionHasAc = _ref.transactionHasAcceptedBuyerOfferAction,
        hasAcceptedBuyerOfferAction = _ref$transactionHasAc === undefined ? false : _ref$transactionHasAc,
        _ref$transactionIsPre = _ref.transactionIsPreAuth,
        isPreAuth = _ref$transactionIsPre === undefined ? false : _ref$transactionIsPre,
        _ref$transactionIsInM = _ref.transactionIsInManualReview,
        isManualReview = _ref$transactionIsInM === undefined ? false : _ref$transactionIsInM,
        _ref$mostRecentOfferI = _ref.mostRecentOfferIsSubmitted,
        offerIsSubmitted = _ref$mostRecentOfferI === undefined ? false : _ref$mostRecentOfferI,
        _ref$mostRecentOfferI2 = _ref.mostRecentOfferIsAccepted,
        offerIsAccepted = _ref$mostRecentOfferI2 === undefined ? false : _ref$mostRecentOfferI2;

    var netTradeable = hasTradePermission && isFurniture;
    return {
        getShowCTAs: function getShowCTAs() {
            var unownedActiveHoldOrItemSold = isOnHold && !ownsActiveHold || isSold;
            var activeNonTradePrice = showSale || !hideRetail;
            var noCompleteTransactionOrOffer = !isBuyerOfferWithReserve && !isFullPriceOrder && !offerIsAccepted && (!offerIsSubmitted || offerIsSubmitted && isPreAuth);
            return {
                showPurchaseCTA: (activeNonTradePrice || netTradeable && (activeNonTradePrice || validNet)) && !unownedActiveHoldOrItemSold && noCompleteTransactionOrOffer,

                showMakeOfferCTA: (showSale && negotiableSale || !hideRetail && negotiableRetail) && !unownedActiveHoldOrItemSold && noCompleteTransactionOrOffer,

                showRequestCTA: !netTradeable && !showSale && hideRetail && !unownedActiveHoldOrItemSold,

                showRequestNetCTA: netTradeable && !showSale && !validNet && !unownedActiveHoldOrItemSold,

                showCheckoutOfferCTA: (hasDealerSubmittedOfferAction || hasAcceptedBuyerOfferAction || offerIsAccepted && isPreAuth && !isManualReview) && !unownedActiveHoldOrItemSold
            };
        },

        getShowPrices: function getShowPrices() {
            var showOnHold = isOnHold && !ownsActiveHold;
            var showRetailPrice = !hideRetail && !showSale && !showOnHold;
            var showNetPrice = netTradeable && validNet && !showSale && !showOnHold;
            var showSalePrice = showSale && !showOnHold;
            return {
                showSalePrice: showSalePrice,
                showNetPrice: showNetPrice,
                showRetailPrice: showRetailPrice,
                showOnHold: showOnHold,

                showPriceUponRequest: !showNetPrice && !showRetailPrice && !showSalePrice,
                showListPriceLabel: netTradeable && showRetailPrice,
                showOnHoldCustom: isOnHold && ownsActiveHold,
                showSold: isSold
            };
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/dibs-display-helpers/dist/buyerDisplayHelper.js
// module id = 1216
// module chunks = 4 5 12